import React, { useEffect, useState } from 'react';

// import { useFetch } from 'hooks/useFetch';

// import { checkCourseStatsEmpty } from './DashboardPage.helpers';

import * as api from 'api/methods';

import DashboardPage from './DashboardPage';

const DashboardPageContainer = (props: any) => {
  const [loading, setLoading] = useState(true);
  // const [isMoreInfo, setIsMoreInfo] = useState(false);
  // const [currentCourse, setCurrentCourse] = useState(null);
  const [currentStudentsStats, setCurrentStudentsStats] = useState(null);
  const [currentStudentsStatsPeriod, setCurrentStudentsStatsPeriod] = useState({
    label: 'Week',
    value: 'week',
  });

  // const { loading: loadingCourses, data: courses } = useFetch(
  //   {
  //     defaultData: [],
  //     fetcher: api.getCourses,
  //     immediately: true,
  //     stopRequest: false,
  //   },
  //   null,
  //   [],
  // );

  // useEffect(() => {
  //   if (courses && courses.length) {
  //     setCurrentCourse(courses[0]);
  //   }
  // }, [courses]);

  useEffect(() => {
    const _getStats = async () => {
      const studentsStats = await api.getStudentsStats(
        currentStudentsStatsPeriod.value,
      );

      setCurrentStudentsStats(studentsStats);

      setLoading(false);
    };

    _getStats();
  }, [currentStudentsStatsPeriod]);

  const handleChangeStudentsStatsPeriod = (period: any) => {
    setCurrentStudentsStatsPeriod(period);
  };

  // const handleMoreInfoToggle = () => {
  //   setIsMoreInfo(!isMoreInfo);
  // };

  // const handleCourseChange = (option) => {
  //   const nextCourse = courses.find((course) => course.id === option.value);
  //   setIsMoreInfo(false);
  //   setCurrentCourse(nextCourse);
  // };

  // const isCurrentCourseStatsEmpty = checkCourseStatsEmpty({
  //   course: currentCourse,
  //   courseStats: currentCourseStats,
  // });

  return (
    <DashboardPage
      {...props}
      loading={loading}
      currentStudentsStats={currentStudentsStats}
      currentStudentsStatsPeriod={currentStudentsStatsPeriod}
      onChangeStudentsStatsPeriod={handleChangeStudentsStatsPeriod}
      // loadingCourses={loadingCourses}
      // loadingCourseStats={loadingCourseStats}
      // isMoreInfo={isMoreInfo}
      // isCurrentCourseStatsEmpty={isCurrentCourseStatsEmpty}
      // courses={courses}
      // currentCourse={currentCourse}
      // currentCourseStats={currentCourseStats}
      // onCourseChange={handleCourseChange}
      // onMoreInfoToggle={handleMoreInfoToggle}
    />
  );
};

export default React.memo(DashboardPageContainer) as any;
